import { S3, config as awsConfig } from 'aws-sdk';
import config from './config';
import strftime from 'strftime'
import logger from "@kemtai/logger"


class CameraRecorder {
  private mediaRecorder: MediaRecorder|null=null;
  private readonly awsS3Bucket: AWS.S3|null = null;
  activeUploads:number = 0
  succCount:number = 0
  failCount:number = 0
  prefix: string=""
  videoBitsPerSecond = config.videoBitsPerSecond
  uploadRate = 0

  constructor(prefix: string="") {
    // Camera stream

    // AWS configuration
    awsConfig.accessKeyId = config.awsAccessKey;
    awsConfig.secretAccessKey = config.awsSecret;
    awsConfig.region = config.awsRegion;
    this.prefix = prefix

    this.awsS3Bucket = new S3({
      useAccelerateEndpoint: config.useAccelerateEndpoint,
      params: {
        Bucket: config.awsS3VideosBucketName,
      },
      httpOptions:{
        timeout: 20 * 60 * 1000 // 20 min!
      }
    });

  }

  start = (stream: MediaStream) => {
    logger.event("Start Video Recording",{videoBitsPerSecond : this.videoBitsPerSecond});
    console.log(">> Start Video Recording",this.videoBitsPerSecond);
    this.mediaRecorder = new MediaRecorder(stream, { mimeType: config.mimeType,
                                                     videoBitsPerSecond : this.videoBitsPerSecond,
    });


    if (this.mediaRecorder.state !== "recording") {
      this.mediaRecorder.ondataavailable = this.onDataAvailable;
      try {
        this.mediaRecorder.start();
      } catch (error) {
        console.dir(error);
      }
    }
  };

  stop = () => {
    logger.event("Stop Video Recording");
    if (this.mediaRecorder?.state === "recording") {
      this.mediaRecorder.stop();
    }
  };
  
  done() {
    this.stop()
    this.mediaRecorder=null;
  }


  onDataAvailable = (e: any) => {
    console.log(`video chunk size: ${e.data.size}`);

    if (e.data.size > 0) {
      this.uploadVideoToS3(e.data);
    }
  };

  stopAndUploadCurrentVideo = () => {
    logger.event("video_upload_request")
    this.stop();
  };

  uploadFileName() {
    const user    = logger.userId;
    const session = logger.sessionId;
    const currentReadableTime = strftime("%Y-%m-%d:%H%M%S",new Date()) ;
    return  `${this.prefix}:${currentReadableTime}:${user}:na:${session}:${Date.now()}.${config.videoExtension}`
  }


  uploadVideoToS3 = async (sessionVideo : Blob) => {
    let fileName = this.uploadFileName()
    console.log("uploadVideoToS3", fileName)
    const params: any = {
      Key: fileName,
      Bucket: config.awsS3VideosBucketName,
      ContentType: config.mimeType,
      Body : new File([sessionVideo], fileName)
    };

    logger.event("video_upload",{fileName,fileSize:sessionVideo.size})
    console.log(sessionVideo.size)
    const fileSize = sessionVideo.size

    if (this.awsS3Bucket !== null) {
      // Uploading the video file
      console.log("uploading ....")
      const started = Date.now()
      this.activeUploads++;
      this.awsS3Bucket.putObject(params, (err) => {
          this.activeUploads --;
          const uploadTime = (Date.now() - started)/1000;
          const uploadRate = Math.round(fileSize / uploadTime)
          console.log(`>> upload time: ${uploadTime} sec. rate=${uploadRate}byte/sec`)
          if (!err) {
            console.log(`upload for ${fileName} has finished successfully`);
            logger.event("video_upload_success",{fileName,uploadTime,uploadRate})
            this.succCount++
          } else {
            console.log(`upload for ${fileName} has finished with error ${err}`);
            logger.event("video_upload_fail",{fileName,uploadTime,uploadRate, error:`${err}`})
            this.failCount++
          }
      });
    }
  };
}

export default CameraRecorder;
